import React, { useContext, useEffect, useState, useMemo } from "react";
import { getAnnotationList } from "../../service/MasterService";
import userContext from "../../context/users/UserContext";
import { useTranslation } from "react-i18next";
import AnnotationColorBox from "./AnnotationColorBox";
import { AuthRoutes } from "../../constants/Constants";
import AddButton from "../../components/AddButton";
import { QueryClient, QueryClientProvider } from 'react-query'
import DataTable from "../../components/DataTable/DataTable";
import { Link, useNavigate } from "react-router-dom";
import loaderContext from "../../context/loader/LoaderContext";
import ColumnsFinding from "./FindingColumns";
import ListViewV3 from "../../components/ListViewV3/ListViewV3";


const queryClient = new QueryClient()

const AnnotationList = () => {
  const navigate = useNavigate();
  const [annotationList, setAnnotationList] = useState([]);
  const [loading,setLoading] = useState(true);
  const { authenticated, loadByUsername } = useContext(userContext);
  const { setLoaderRunning, ref} = useContext(loaderContext);
  const [t, i18n] = useTranslation();
  function camelToUnderscore(key) {
    var result = key.replace(/([A-Z])/g, " $1");
    return result.split(" ").join("_").toLowerCase();
  }

  const [paginationObj, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const [filterObj, setFilterObj] = useState({
    filterInput: null,
    filterUpdate: 0,
  });
  const [sortObj, setSortObj] = useState({
    sortFieldText: "",
    sortFieldValue: "",
    sortDir: false,
    selected: false,
  });


  const fetchAnnotationList = async (page, pageSize, pageSortBy) => {
    if(!authenticated){
      console.log("CALLING LOAD BY USERNAME FROM ANNOTATION LIST")
      await loadByUsername();
    }
    let sortyByDir = true;
    let sortParams = "id";
    if (pageSortBy != undefined && pageSortBy.length > 0) {
      sortParams = pageSortBy[0].id;
      sortyByDir = pageSortBy[0].desc;
    }

    const body = {
      paginationDto: {
        pageNumber: page,
        pageSize: pageSize,
        sortField: camelToUnderscore(sortParams),
        sortOrder: sortyByDir,
      },
    };
    var list = [];
      const response = await getAnnotationList(body);
      if (response.status === 200 && response.data.result === "SUCCESS") {
        response.data.data.annotationList.forEach(element => {
          list.push({
            "id":element.id,
            "name":element.name,
            "color": <AnnotationColorBox color={element.color}/>,
            "modality": element.modalityList.join(", ")
        });
      });
      setAnnotationList(list);
      setLoading(false);
      const data = {
        results: list,
        count: response.data.data.totalElements
      }
      return data;
  }

  };

  const handleUserClick = async (cell) => {
    // navigate("/annotation/view?id="+cell.row.original.id, {
    //   state: {
    //     annotation_id : cell.row.original.id,
    //     annotation_name: cell.row.original.name
    //   }
    // });
  }
 

  // const columns = useMemo(
  //   () => [
  //     {
  //       Header: "Annotation Name",
  //       key:"annotation_name",
  //       accessor: "name",
  //       className: "ms-Grid-col ms-sm6 ms-md4 ms-lg1",
  //       classChildName: "ms-Grid-col ms-sm6 ms-md4 ms-lg1 break-word cursor-pointer",
  //       sorting:true,
  //       Cell: ({ cell }) => <><p className="user-view-link" onClick={() => handleUserClick(cell)}>{cell.row.values.name}</p></>,
  //     },
  //     {
  //         Header: "Color",
  //         key:"color",
  //         accessor: "color",
  //         className: "ms-Grid-col ms-sm6 ms-md4 ms-lg1 blue",
  //       classChildName: "ms-Grid-col ms-sm6 ms-md4 ms-lg1",
  //     },
  //     {
  //       Header: "Modality",
  //       accessor: "modality",
  //       className: "ms-Grid-col ms-sm6 ms-md4 ms-lg1 blue",
  //       classChildName: "ms-Grid-col ms-sm6 ms-md4 ms-lg1",
  //   }
  //   ]
  // );

  const fetchData = async (options) => {
    
    setLoaderRunning(true);
    ref.current.continuousStart();
    try{

      let data = null;
      let pageCount = null;  

      let sortParams = "id";
    let sortyByDir = false;

    if (
      options.sortObj.sortFieldValue != undefined &&
      options.sortObj.sortFieldValue.length > 0
    ) {
      sortParams = options.sortObj.sortFieldValue;
      sortyByDir = options.sortObj.sortDir;
    }

    const body = {
      paginationDto: {
        pageNumber: options.page,
        pageSize: options.pageSize,
        sortField: camelToUnderscore(sortParams),
        sortOrder: sortyByDir,
      },
    };

      const response = await getAnnotationList(body);
      console.log("--- Calling fetchData---");
      if (response.status === 200 && response.data.result === "SUCCESS") {
        setLoaderRunning(false);
        ref.current.complete();
        console.log("--- Res ----",response);
        
        if (response.status === 200 && response.data.result === "SUCCESS") {
          let list = [];
          response.data.data.annotationList.forEach(element => {
            list.push({
              "id":element.id,
              "name":element.name,
              "color": <AnnotationColorBox color={element.color}/>,
              "modality": element.modalityList.join(", ")
          });
        });
        setAnnotationList(list);
        data = list;
        return {
          rows: data,
          pageCount: response.data.data?.totalPages,
        };
      }
      }else{
        setLoaderRunning(false);
        ref.current.complete();
        return {
          rows: data,
          pageCount: pageCount,
        }
      }
    }catch(e){
      console.log("--- Error ----",e);
      setLoaderRunning(false);
      ref.current.complete();
    }
  };

  const columns = ColumnsFinding();
  return (
    <>
    {/* <div style={{ padding: "10px 2%" }}>
      <div className="listPage-headerDiv">
        <p className="listPage-header">Annotation</p>
      </div>
      <Link to={AuthRoutes.ADDANNOTATION}>
        <AddButton text="Add Annotation"/>
      </Link>
          <QueryClientProvider client={queryClient}>
            <DataTable 
              fetchFunction={fetchAnnotationList} 
              columns={columns} 
              // filterObj={getFilteredList}
            />
          </QueryClientProvider>
        </div> */}

<div className="main-container-body">  
      <ListViewV3 
              buttonsTopBar={[]}
              fetchData = {fetchData}
              columns={columns}
              filterObj={filterObj}
              setFilterObj={setFilterObj}
              sortObj = {sortObj}
              setSortObj = {setSortObj}
              setPagination = { setPagination}
              paginationObj = {paginationObj}
              handleUserClick={handleUserClick}
              uniqueKey= {"finding"}
              heading={t("navbar.findings")}
              showFilter={false}
              enhancedFilter={false}
              showSort={false}
              showPagination = {true}
              extraMargin={false}
              pointer={false}
              
            />
      </div>  
    </>
  );
};

export default AnnotationList;
